export const mockPackages = [
  {
    packageId: "PKG-2891",
    warehouse: "Baku Central",
    destination: "Istanbul, Turkey",
    sender: "Tech Corp LLC",
    recipient: "Aydin Mammadov",
    address: "Nizami küç. 123, Bakı",
    phone: "+994 55 123 4567",
    courierName: "John Smith",
    status: "IN_TRANSIT",
    eta: "Mar 26, 2026",
    notes: "Fragile items. Handle with care."
  },
  {
    packageId: "PKG-2890",
    warehouse: "Istanbul Hub",
    destination: "Baku, Azerbaijan",
    sender: "Import Solutions",
    recipient: "Leyla Hasanova",
    address: "Atatürk prospekti 45, Bakı",
    phone: "+994 50 987 6543",
    courierName: "Maria Garcia",
    status: "ASSIGNED",
    eta: "Mar 25, 2026",
    notes: "Call before delivery."
  },
  {
    packageId: "PKG-2889",
    warehouse: "Baku Central",
    destination: "Ganja, Azerbaijan",
    sender: "Fresh Market",
    recipient: "Rashad Aliyev",
    address: "Heydər Əliyev prospekti 12, Gəncə",
    phone: "+994 70 555 4433",
    courierName: "Ahmed Hassan",
    status: "COMPLETED",
    eta: "Mar 24, 2026",
    notes: "Delivered to neighbor."
  }
];

export const initialMockCouriers = [
  { id: "CUR-001", name: "John Smith", phone: "+994 50 123 4567", email: "john.smith@smartcargo.com", deliveries: 234, rating: 4.8, status: "active", vehicle: "VH-101" },
  { id: "CUR-002", name: "Maria Garcia", phone: "+994 55 234 5678", email: "maria.garcia@smartcargo.com", deliveries: 198, rating: 4.9, status: "active", vehicle: "VH-102" },
  { id: "CUR-003", name: "Ahmed Hassan", phone: "+994 50 345 6789", email: "ahmed.hassan@smartcargo.com", deliveries: 187, rating: 4.7, status: "on-break", vehicle: "VH-103" },
  { id: "CUR-004", name: "Li Wei", phone: "+994 55 456 7890", email: "li.wei@smartcargo.com", deliveries: 165, rating: 4.6, status: "active", vehicle: "VH-104" },
  { id: "CUR-005", name: "Sarah Johnson", phone: "+994 50 567 8901", email: "sarah.johnson@smartcargo.com", deliveries: 142, rating: 4.9, status: "offline", vehicle: "VH-105" },
];

export const mockVehicles = [
  {
    id: 'VH-101',
    type: 'Cargo Van',
    status: 'ACTIVE',
    currentRoute: 'Baku → Istanbul',
    assignedCourier: { name: 'John Smith', phone: '+994 50 123 4567' },
    lastMaintenanceDate: 'Mar 10, 2026'
  },
  {
    id: 'VH-102',
    type: 'Delivery Truck',
    status: 'ACTIVE',
    currentRoute: 'Istanbul → Baku',
    assignedCourier: { name: 'Maria Garcia', phone: '+994 55 234 5678' },
    lastMaintenanceDate: 'Mar 15, 2026'
  },
  {
    id: 'VH-103',
    type: 'Cargo Van',
    status: 'IDLE',
    currentRoute: 'Warehouse',
    assignedCourier: null,
    lastMaintenanceDate: 'Mar 12, 2026'
  },
  {
    id: 'VH-104',
    type: 'Box Truck',
    status: 'ACTIVE',
    currentRoute: 'Ganja → Baku',
    assignedCourier: { name: 'Li Wei', phone: '+994 55 456 7890' },
    lastMaintenanceDate: 'Mar 18, 2026'
  },
  {
    id: 'VH-105',
    type: 'Cargo Van',
    status: 'MAINTENANCE',
    currentRoute: 'Maintenance Bay',
    assignedCourier: null,
    lastMaintenanceDate: 'Mar 20, 2026'
  }
];

export const mockWarehouses = [
  {
    id: "WH-001",
    name: "Baku Central",
    location: "Nasimi District, Baku",
    capacity: 5000,
    currentStock: 3847,
    incoming: 234,
    outgoing: 189,
    coordinates: { lat: 40.4093, lng: 49.8671 }
  },
  {
    id: "WH-002",
    name: "Istanbul Hub",
    location: "Beylikdüzü, Istanbul",
    capacity: 8000,
    currentStock: 5234,
    incoming: 456,
    outgoing: 398,
    coordinates: { lat: 41.0082, lng: 28.9784 }
  },
  {
    id: "WH-003",
    name: "Sumgait Warehouse",
    location: "Industrial Zone, Sumgait",
    capacity: 3000,
    currentStock: 1892,
    incoming: 145,
    outgoing: 123,
    coordinates: { lat: 40.5897, lng: 49.6686 }
  },
  {
    id: "WH-004",
    name: "Ganja Depot",
    location: "Nizami District, Ganja",
    capacity: 2500,
    currentStock: 1456,
    incoming: 89,
    outgoing: 76,
    coordinates: { lat: 40.6828, lng: 46.3606 }
  }
];

export const initialMockAdmins = [
  { id: "ADM-001", name: "Alice Masterson", email: "alice@smartcargo.com", status: "active" },
  { id: "ADM-002", name: "Bob Builder", email: "bob@smartcargo.com", status: "active" },
  { id: "ADM-003", name: "Charlie Delta", email: "charlie@smartcargo.com", status: "blocked" },
];
